'use client'

import cn from 'classnames'
import { useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { Modal } from '@booking/components/Modal'
import styles from '../index.module.scss'

type RestrictionItem = {
  title?: string
  content: string
}

export default function AdultRestrictionsModal({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const t = useTranslations('booking')

  const items = useMemo<RestrictionItem[]>(() => {
    const raw = t.raw('ticket.selectQuantity.adultRestrictions.items') as unknown
    return Array.isArray(raw) ? (raw as RestrictionItem[]) : []
  }, [t])

  return (
    <Modal modalIsOpen={open} setModalIsOpen={onOpenChange} className={cn(styles.modal)}>
      <h3 className={styles.title}>{t('ticket.selectQuantity.adultRestrictions.title')}</h3>

      {items.map((item, index) => (
        <div className={cn(styles.item)} key={index}>
          {item.title ? <strong>{item.title}</strong> : null}
          <div dangerouslySetInnerHTML={{ __html: item.content }} />
        </div>
      ))}
    </Modal>
  )
}
